'use strict';
import {module} from '../app';
import * as _ from 'lodash';

let handleMethod = null;
let messageTimeout = null;

module.controller('PatientCtrl', [
  '$scope', '$stateParams', 'patientViewModel', '$location', '$rootScope', '$state', 'tpConfig', '$sce',
  function ($scope, $stateParams, patientViewModel, $location, $rootScope, $state, tpConfig, $sce) {
    const id = $stateParams.id;
    const isViewOnly = $location.search().viewOnly;
    const returnUrl = $location.search().returnUrl;
    const isMyPatientMode = $location.search().isMyPatientMode;

    $scope.vm = new patientViewModel(id, isViewOnly, returnUrl, isMyPatientMode);

    $scope.vm._initWithId(id);
    $scope.vm.$scope = $scope;

    if (!handleMethod) {

      handleMethod = function (m) {
        if (messageTimeout) {
          clearTimeout(messageTimeout);
        }

        setTimeout(() => {
          $scope.vm.handlePortalIframeMessage(m);
          
          clearTimeout(messageTimeout);
        }, 200);
      };
    }

    window.addEventListener("message", handleMethod, false);
    let unsubscribeStatusChange = $rootScope.$on('status-change', function (ev, data) {
      $scope.vm.updateOnlineStatus(data);
    });

    $scope.$on(tpConfig.events.givingUpReconnecting, (ev, data) => {
      $scope.vm.onGivingUpReconnecting();
    });

    $scope.$on('$destroy', function () {
      unsubscribeStatusChange();
      window.removeEventListener("message", handleMethod, false);
      handleMethod = null;
      $scope.vm.onDestroy();
    });

  }]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/patient.js